import { RadioInput, BaseOptions } from '@g17eco/molecules/form';
import { QUESTION } from '@constants/terminology';
import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { useContext } from 'react';
import { Label } from 'reactstrap';
import { QuestionManagementContext } from '@features/question-management/QuestionManagementContainer';
import { MetricOverrideType, METRIC_OVERRIDE_CODES, UtrvConfigCode, UtrvConfigValue } from './types';
import { getLabelByCode, getOptionsByCode } from './utils';

interface Props {
  hasAnythingChanged: boolean;
  form: MetricOverrideType;
  handleChange: (props: { code: UtrvConfigCode; value: UtrvConfigValue }) => void;
}

export const MultipleMetricOverride = (props: Props) => {
  const { hasAnythingChanged, form, handleChange } = props;
  const { metricOverrideCode, setMetricOverrideCode } = useContext(QuestionManagementContext);

  if (!metricOverrideCode) {
    return null;
  }

  const codeOptions = METRIC_OVERRIDE_CODES.map((code) => ({ label: getLabelByCode(code), value: code }));
  const valueOptions = getOptionsByCode(metricOverrideCode).map((op) => ({ name: op.label, code: op.value }));
  const value = form[metricOverrideCode];

  return (
    <div>
      <Label className='mb-1'>
        <span className='fw-semibold'>Override</span>
        {hasAnythingChanged ? (
          <SimpleTooltip
            text={`Please save or cancel your change before making additional overrides to these ${QUESTION.PLURAL}`}
          >
            <i className='fal fa-bell-exclamation text-ThemeWarningMedium ml-2' />
          </SimpleTooltip>
        ) : null}
      </Label>
      <SelectFactory
        selectType={SelectTypes.SingleSelect}
        options={codeOptions}
        onChange={(op) => op?.value && setMetricOverrideCode(op.value)}
        isSearchable={false}
        value={codeOptions.find((op) => op.value === metricOverrideCode) ?? null}
        className='mb-3'
        isDisabled={hasAnythingChanged}
        isMenuPortalTargetBody
      />
      <RadioInput
        groupCode={metricOverrideCode}
        value={value}
        options={valueOptions}
        onChange={handleChange as BaseOptions['onChange']}
        formGroupClassName='mt-2'
      />
    </div>
  );
};
